import { graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import * as React from "react"
import ReactHtmlParser from 'react-html-parser'
import Feature from "./feature"
import { Base, Container, Heading } from "./ui"
import * as styles from "./ui.css"

export default function FeatureList(props) {
  const bgImage = convertToBgImage(getImage(props.smallBackground));

  return (
    <Container width='full' cx={[styles.containerFeatureList]}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Heading variant={"secondaryHeading"} cx={[styles.secondaryHeading]}>
          {ReactHtmlParser(props.heading)}
        </Heading>
      </div>
      <Base as="div" cx={[styles.productsHorzList]}>
        {props.content.map((feature, i) => {
          return (
            <Feature key={feature.id} {...feature} first={i == 0} last={i == props.content.length - 1} />
          );
        })}
      </Base>
    </Container >
  )
}

export const query = graphql`
  fragment HomepageFeatureListContent on HomepageFeatureList {
    id
    kicker
    heading
    text
    leftSide
    imageMain {
      id
      gatsbyImageData(breakpoints: [800,1100,1500] )
      alt
    }
    smallImage {
      id
      gatsbyImageData(width: 800)
      alt
    }
    smallBackground {
      id
      gatsbyImageData(width: 800)
      alt
    }
    content {
      id
      ...HomepageFeatureContent
    }
  }
`
